import React from 'react';
import ReportSection from "../../components/ReportDropdown";
import Certi from "../../components/Certi";
import Reports from './Reports';

const ViewContract = () => {
  const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false) => {
    // Define color mappings
    const bgColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };
  
    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };
  
    return (
      <div className="flex items-center">
        {/* Button Text */}
        <div className={`${bgColorClasses[bgColor]} text-white md:text-[16px] text-[5px] px-2 md:px-4 ${
          isLarge ? "md:py-[14px] py-[3px]" : "md:py-[14px] py-[3px]"
        } md:rounded-l-md rounded-l-md font-bold md:w-[300px] whitespace-nowrap flex items-center h-full`}>
          {text}
        </div>
        
        {/* Desktop Icon (visible on md and up) */}
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-2  justify-center md:w-[57px] md:h-[52px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
            alt="Expand"
            className="w-[20px] h-[6px] md:h-[40px] md:w-[55px]  object-contain"
          />
        </div>
        
        {/* Mobile Icon (visible below md) */}
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px]  h-[14px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
            alt="Expand"
            className="w-[20px] h-[6px]  object-contain"
          />
        </div>
      </div>
    );
  };

  return (
    <div className='bg-white'>
      <div className='container mx-auto px-3 sm:px-5 md:px-8 lg:px-10 py-3 sm:py-5 md:py-6 lg:py-8'> 
        {/* Header Section */}
        <div className='mb-4 sm:mb-6 md:mb-8'>
          <h1 className='text-[12px] sm:text-[18px] md:text-[24px] lg:text-[36px] font-bold text-[#152C24]'>CONTRACTS</h1>
          <h1 className="font-bold text-[#979797] text-[6px] sm:text-[10px] md:text-[16px] lg:text-[24px] mt-1 sm:mt-3 md:mt-4 lg:mt-6">
            Contract Farming | <span className='text-black'> African Marmalade</span>
          </h1>
          
          {/* Search Bar */}
          <div className="w-full my-2 sm:my-4 md:my-6 lg:my-8">
            <div className="relative">
              <input
                placeholder="Search"
                type="text"
                className="w-full h-8 sm:h-10 md:h-12 lg:h-16 text-[#979797] text-[6px] sm:text-[8px] md:text-[10px] lg:text-[16px] font-bold pl-3 sm:pl-4 md:pl-5 lg:pl-6 pr-8 sm:pr-10 md:pr-11 lg:pr-12 border border-[#C4C4C4] rounded-full sm:rounded-lg focus:outline-none focus:ring-1 sm:focus:ring-2 focus:ring-green-600"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
                alt="Search Icon"
                className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 absolute right-2 sm:right-3 md:right-4 lg:right-6 top-1/2 transform -translate-y-1/2"
              />
            </div>
            <p className="text-[4px] sm:text-[6px] md:text-[8px] lg:text-[14px] mt-1 sm:mt-1 md:mt-2">Enter User name or ID Number to search.</p>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row items-center gap-3 sm:gap-5 md:gap-10 md:mt-10 lg:gap-24">
  {/* Image Section */}
  <div className="w-full lg:w-auto">
    <h1 className='text-[6px] sm:text-[10px] md:text-[14px] lg:text-[20px] font-extrabold mb-2 sm:mb-3'>Dallan Farm</h1>
    <div className="flex flex-col items-center lg:items-end">
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750524343/image_3_bvld0g.png"
        alt="Contract Agreement"
        className="w-[120px] xs:w-[150px] sm:w-[200px] md:w-[300px] lg:w-[304px] h-auto max-h-[120px] xs:max-h-[150px] sm:max-h-[200px] md:max-h-[400px] lg:h-[403px] object-contain "
      />
      <div className="flex items-center mt-1 sm:mt-2 md:mt-3 lg:mt-4 cursor-pointer text-[6px] sm:text-[8px] md:text-[10px] lg:text-[16px] text-gray-700 hover:text-green-700 transition">
        <span>Download</span>
        <img 
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750524341/Send_light_ctfswr.png" 
          alt="Download" 
          className='w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 ml-1 sm:ml-2'
        />
      </div>
    </div>
  </div>

  {/* Text Content */}
  <div className="flex-1 mt-3 sm:mt-4 md:mt-5 lg:-mt-10">
    <h2 className="text-[10px] sm:text-[16px] md:text-[24px] lg:text-[36px] font-bold mb-2 sm:mb-3 md:mb-4 lg:mb-6">About Contract:</h2>
    <p className="text-[6px] sm:text-[10px] md:text-[14px] lg:text-[24px] text-black mb-1 sm:mb-2 md:mb-3 lg:mb-5">
      Market Access and Price Stability: FarmNet aims to provide farmers with access to guaranteed markets and price stability through contract farming agreements. This approach helps mitigate the risks associated with fluctuating market prices.
    </p>
    <h2 className="text-[10px] sm:text-[16px] md:text-[24px] lg:text-[36px] font-bold mb-1 sm:mb-2 md:mb-3 lg:mb-5">Produce</h2>

    {/* Product Boxes */}
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-1 sm:gap-2">
      {['Castor', 'Cow Pease', 'Beans', 'Potatoes', '-', '-', '-', '-'].map((item, index) => (
        <div 
          key={index}
          className={`h-4 sm:h-6 md:h-8 lg:h-12 rounded flex items-center justify-center text-[4px] sm:text-[6px] md:text-[8px] lg:text-[14px] ${
            index === 0 ? 'bg-[#152C24] text-white' : 'bg-[#CFD7D7]'
          }`}
        >
          {item}
        </div>
      ))}
    </div>
  </div>
</div>
        
        <h1 className="font-bold text-[#979797] text-[6px] sm:text-[10px] md:text-[16px] lg:text-[24px] mt-3 sm:mt-5 md:mt-8 lg:mt-10">
          Contract Farming | <span className='text-black'> Reports</span>
        </h1>
        
        <div className='flex items-end justify-end mt-2 sm:mt-3 md:mt-4'>
          <ReportSection/>
        </div>

        <Reports/>
        
        <h1 className="font-bold text-black  text-[8px] sm:text-[12px] md:text-[18px] lg:text-[36px] mt-3 sm:mt-5 md:mt-8 lg:mt-10">
          Contract Farmers
        </h1>
        
        <Certi/>
        
        <div className='flex justify-end mt-3 sm:mt-5 md:mt-6 lg:mt-8 mb-2 sm:mb-3'>
          <div>
            {renderButtonWithIcon("DOWNLOAD REPORTS", "#152C24", "#FDBB26", true)}
            <p className="text-[4px] sm:text-[6px] md:text-[8px] lg:text-[14px] font-normal mt-1">Click to download reports</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewContract;